import { cloneDeepWith } from 'lodash-es';

export const trimData = <T>(data: T): T =>
  cloneDeepWith(data, (value) => {
    if (typeof value === 'string') {
      return value.trim();
    }
    return undefined; // Let cloneDeepWith handle cloning of non-string values
  }) as T;
